import React from "react";
import { Login, SIGN_UP } from "../Login/Login";
import { useGA } from "../../common/hooks";

export const Register = () => {
    useGA();
    return <Login defaultTab={SIGN_UP} />;
};
